/**
 * Awtomic Cart Rollup v1.0.0 — CONSOLE VERSION
 * Paste into browser console for testing. Debug mode is always ON.
 * Combines theme definitions + cart extras into a single IIFE.
 */
(function () {
  'use strict';

  // ── Theme Definitions (inlined) ────────────────────────────────────────────

  var has = function (s) {
    return !!document.querySelector(s);
  };

  var TABLE_SELECTORS = {
    cartItemRow: 'tr[data-key]',
    title: '.cart-items__title',
    image: '.cart-items__media-image',
    imageContainer: '.cart-items__media-container',
    imageLink: '.cart-items__link',
    variants: '.cart-items__variants',
    variantsWrapper: '.cart-items__variants-wrapper',
    unitPriceWrapper: '.cart-items__unit-price-wrapper',
    price: '.cart-items__price',
    compareAtPrice: '.compare-at-price',
    qtyInput: 'input[type="number"]',
    qtyButtons: '.quantity-minus, .quantity-plus',
    removeButton: '.cart-items__remove',
  };

  var BUBBLE = {
    count: '.cart-bubble__text-count',
    visuallyHidden: '.cart-bubble__text .visually-hidden',
    container: '.cart-bubble',
  };

  var BUBBLE_WIDE = {
    count:
      '[data-testid="cart-bubble"], .cart-count, [id*="cart-count"], .cart-count-bubble span[aria-hidden="true"], .cart-bubble__text-count',
    visuallyHidden: '.visually-hidden',
    container: '.cart-bubble, .cart-count-bubble',
  };

  var themeDefinitions = {
    themes: {
      tinker: {
        name: 'Tinker',
        detect: function () {
          return (
            has('dialog.cart-drawer__dialog') &&
            has('cart-items-component[data-drawer]')
          );
        },
        selectors: TABLE_SELECTORS,
        drawer: {
          selectors: 'dialog.cart-drawer__dialog[open], dialog[open]',
          visibilityCheck: function (el) {
            return el && el.hasAttribute('open');
          },
          itemsComponent: 'cart-items-component[data-drawer]',
          closestContainer: 'dialog.cart-drawer__dialog',
        },
        cartBubble: BUBBLE,
      },

      horizon: {
        name: 'Horizon',
        detect: function () {
          return has('tr[data-key]') && has('.cart-items__title');
        },
        selectors: TABLE_SELECTORS,
        drawer: {
          selectors: 'cart-drawer, [data-drawer], .cart-drawer, #cart-drawer',
          visibilityCheck: function (el) {
            return (
              el &&
              (el.offsetParent ||
                el.hasAttribute('open') ||
                el.classList.contains('active') ||
                el.classList.contains('is-open'))
            );
          },
          itemsComponent: 'cart-items-component[data-drawer]',
          closestContainer: 'cart-drawer, .cart-drawer',
        },
        cartBubble: BUBBLE,
      },

      wonder: {
        name: 'Wonder',
        detect: function () {
          return has('.wt-cart__item') || has('.wt-cart__list');
        },
        selectors: {
          cartItemRow: 'li.wt-cart__item',
          title: '.wt-cart__item__name a',
          image: 'img.card__img',
          imageContainer: 'picture.wt-cart__item__thumb',
          imageLink: 'picture.wt-cart__item__thumb a.wt-cart__item__link',
          variants: '.options',
          variantsWrapper: '.wt-cart__item__data',
          unitPriceWrapper: '.wt-cart__item__price-wrapper',
          price: 'span.price.price--end',
          compareAtPrice: 's.cart-item__old-price',
          qtyInput: 'input.js-counter-quantity',
          qtyButtons: '.js-counter-button',
          removeButton: 'cart-remove-button a, a.wt-cart__item__remove',
        },
        drawer: {
          selectors:
            'cart-drawer-items.wt-cart__drawer__items, .wt-cart__drawer__body',
          visibilityCheck: function (el) {
            return el && el.offsetParent !== null;
          },
          itemsComponent: 'cart-drawer-items.wt-cart__drawer__items',
          closestContainer: '.wt-cart__drawer__body',
        },
        cartBubble: BUBBLE_WIDE,
      },

      dawn: {
        name: 'Dawn',
        detect: function () {
          var onCart = window.location.pathname.includes('/cart');
          return (
            has('quantity-popover') ||
            has('cart-remove-button') ||
            has('cart-items') ||
            (onCart &&
              (has('.cart-item__name') || has('.cart-item__image-container')))
          );
        },
        selectors: {
          cartItemRow: 'tr.cart-item, .cart-item',
          title: '.cart-item__name, a.cart-item__name',
          image: '.cart-item__image',
          imageContainer: '.cart-item__image-container',
          imageLink: 'a.cart-item__link',
          variants: '.product-option',
          variantsWrapper: '.cart-item__details',
          unitPriceWrapper: '.unit-price, .cart-item__totals',
          price: '.price--end, .product-option',
          compareAtPrice: '.price--end',
          qtyInput: 'input.quantity__input',
          qtyButtons: '.quantity__button',
          removeButton: 'cart-remove-button a, .cart-remove-button a',
        },
        drawer: null,
        cartBubble: {
          count: '.cart-count-bubble span[aria-hidden="true"]',
          visuallyHidden: '.cart-count-bubble .visually-hidden',
          container: '.cart-count-bubble',
        },
      },

      supply: {
        name: 'Supply',
        detect: function () {
          return (
            (has('#CartDrawer.drawer, .drawer#CartDrawer') ||
              has('[data-products]') ||
              window.location.pathname.includes('/cart')) &&
            has('.cart__items, .cart__item')
          );
        },
        selectors: {
          cartItemRow: '.cart__item[data-key]',
          title: '.cart__item-name',
          image: '.cart__image img',
          imageContainer: '.cart__image',
          imageLink: '.cart__image a',
          variants: '.cart__item--variants',
          variantsWrapper: '.cart__item-details',
          unitPriceWrapper: '.cart__item-price-col',
          price: '.cart__price',
          compareAtPrice: '.cart__price--strikethrough',
          qtyInput: 'input.js-qty__num',
          qtyButtons: '.js-qty__adjust',
          removeButton: '.cart__remove a',
        },
        drawer: {
          selectors: '#CartDrawer.drawer--is-open, .drawer.drawer--is-open',
          visibilityCheck: function (el) {
            return el && el.classList.contains('drawer--is-open');
          },
          itemsComponent: '.cart__items',
          closestContainer: '#CartDrawer, .drawer',
        },
        cartBubble: BUBBLE_WIDE,
      },

      rebuy: {
        name: 'Rebuy',
        detect: function () {
          return has('#rebuy-cart, .rebuy-cart');
        },
        selectors: {
          cartItemRow: 'li.rebuy-cart__flyout-item',
          title: '.rebuy-cart__flyout-item-product-title',
          image: '.rebuy-cart__flyout-item-media img',
          imageContainer: '.rebuy-cart__flyout-item-media',
          imageLink: '.rebuy-cart__flyout-item-media a',
          variants: '.rebuy-cart__flyout-item-discount-message',
          variantsWrapper: '.rebuy-cart__flyout-item-info',
          unitPriceWrapper: '.rebuy-cart__flyout-item-price',
          price:
            '.rebuy-money.sale span[tabindex], .rebuy-money span[tabindex]',
          compareAtPrice: '.rebuy-money.compare-at span',
          qtyInput: '.rebuy-cart__flyout-item-quantity-widget-label',
          qtyButtons: '.rebuy-cart__flyout-item-quantity-widget-button',
          removeButton: '.rebuy-cart__flyout-item-remove',
        },
        drawer: {
          selectors:
            '#rebuy-cart.is-visible, #rebuy-cart[aria-hidden="false"], .rebuy-cart.is-visible',
          visibilityCheck: function (el) {
            return (
              el &&
              (el.classList.contains('is-visible') ||
                el.getAttribute('aria-hidden') === 'false')
            );
          },
          itemsComponent: 'ul[data-smartcart-items]',
          closestContainer: '#rebuy-cart, .rebuy-cart',
        },
        cartBubble: BUBBLE_WIDE,
      },

      debut: {
        name: 'Debut',
        detect: function () {
          return (
            has('[data-section-type="cart-template"]') &&
            has('.list-view-item__title')
          );
        },
        selectors: {
          cartItemRow: 'tr.cart__row',
          title: '.list-view-item__title a',
          image: 'img.cart__image',
          imageContainer: '.cart__image-wrapper',
          imageLink: '.cart__image-wrapper a',
          variants: '.cart__meta-text',
          variantsWrapper: '.cart__meta',
          unitPriceWrapper: '.cart__price-wrapper',
          price: 'td.text-right.small--hide > div',
          compareAtPrice: '.cart__original-price',
          qtyInput: 'input.cart__qty-input',
          qtyButtons: '.cart__qty-adjust',
          removeButton: 'a.cart__remove',
        },
        drawer: null,
        cartBubble: {
          count: '#CartCount > span:first-child',
          visuallyHidden: '#CartCount .icon__fallback-text',
          container: '#CartCount',
        },
      },

      generic: {
        name: 'Generic',
        detect: function () {
          return true;
        },
        selectors: {
          cartItemRow: '[data-key]',
          title: 'a[href*="/products/"]',
          image: 'img[src*="cdn.shopify.com"]',
          imageContainer: '.image-container, .media-container',
          imageLink: 'a[href*="/products/"]',
          variants: 'dl, .variant',
          variantsWrapper: '.variants-wrapper, .product-options',
          unitPriceWrapper: '.price-wrapper, .unit-price',
          price: '.price, .money',
          compareAtPrice: '.compare-at-price, .was-price',
          qtyInput: 'input[type="number"]',
          qtyButtons: 'button[name*="plus"], button[name*="minus"]',
          removeButton: 'button[class*="remove"], a[class*="remove"]',
        },
        drawer: {
          selectors:
            'cart-drawer, [data-drawer], .cart-drawer, #cart-drawer, dialog[open]',
          visibilityCheck: function (el) {
            return (
              el &&
              (el.offsetParent ||
                el.hasAttribute('open') ||
                el.classList.contains('active') ||
                el.classList.contains('is-open'))
            );
          },
          itemsComponent: 'cart-items-component[data-drawer]',
          closestContainer: 'cart-drawer, .cart-drawer, dialog',
        },
        cartBubble: BUBBLE_WIDE,
      },
    },

    detectionOrder: [
      'tinker',
      'horizon',
      'wonder',
      'dawn',
      'supply',
      'debut',
      'generic',
    ],
  };

  // ── Cart Extras (debug always on) ──────────────────────────────────────────

  const customConfig = window.awtomicCartExtrasConfig || {};
  const DEBUG_MODE = true; // Console version: always on

  const debug = (...args) => {
    console.log('[Awtomic Cart Rollup]', ...args);
  };

  const isRebuy = (name) => name === 'Rebuy' || name === 'rebuy';
  const isWonder = (name) => name === 'Wonder' || name === 'wonder';
  const isDirectTheme = (name) =>
    isRebuy(name) || name === 'Supply' || isWonder(name);

  let pollInterval = null;
  let lastVisibleCarts = { rebuy: false, drawer: false };

  const detectTheme = () => {
    if (customConfig.theme && typeof customConfig.theme === 'object') {
      debug('Using custom theme:', customConfig.theme.name || 'Custom');
      return {
        name: customConfig.theme.name || 'Custom',
        detect: customConfig.theme.detect || (() => true),
        selectors: customConfig.theme.selectors || {},
        drawer: customConfig.theme.drawer ?? null,
        cartBubble: customConfig.theme.cartBubble || null,
      };
    }

    for (const key of themeDefinitions.detectionOrder) {
      const theme = themeDefinitions.themes[key];
      if (theme?.detect?.()) {
        debug(`Detected theme: ${theme.name}`);
        return theme;
      }
    }

    return (
      themeDefinitions.themes.generic || {
        name: 'Fallback',
        detect: () => true,
        selectors: {},
        drawer: null,
        cartBubble: null,
      }
    );
  };

  let THEME = detectTheme();

  debug('='.repeat(60));
  debug('CONSOLE VERSION — Debug Mode Always On');
  debug('Version: 1.0.0');
  debug('Theme:', THEME.name);
  debug('Custom Config:', customConfig.theme ? 'Yes' : 'No');
  debug('Has Drawer:', THEME.drawer ? 'Yes' : 'No');
  debug('='.repeat(60));

  const injectAntiFlickerCSS = () => {
    const style = document.createElement('style');
    style.id = 'awtomic-cart-antiflicker';
    style.textContent = `
      body:not(.awtomic-cart-processed) .cart__items:not(.awtomic-ready),
      body:not(.awtomic-cart-processed) [data-products]:not(.awtomic-ready),
      body:not(.awtomic-cart-processed) .rebuy-cart__flyout-items:not(.awtomic-ready),
      body:not(.awtomic-cart-processed) .cart-items__table:not(.awtomic-ready),
      body:not(.awtomic-cart-processed) cart-items-component[data-drawer]:not(.awtomic-ready),
      body:not(.awtomic-cart-processed) .wt-cart__list:not(.awtomic-ready),
      body:not(.awtomic-cart-processed) [data-section-type="cart-template"] table tbody:not(.awtomic-ready) {
        visibility: hidden !important;
        opacity: 0 !important;
      }
    `;
    document.head.appendChild(style);

    // Permanent styles (not removed with anti-flicker)
    const permanent = document.createElement('style');
    permanent.id = 'awtomic-cart-rollup-styles';
    permanent.textContent = `
      tbody.awtomic-original { display: none !important; }
      tbody.awtomic-processed { display: table-row-group !important; }
    `;
    document.head.appendChild(permanent);
  };

  const removeAntiFlickerCSS = () => {
    document.body.classList.add('awtomic-cart-processed');
    setTimeout(() => {
      const style = document.getElementById('awtomic-cart-antiflicker');
      if (style) {
        style.remove();
      }
    }, 1000);
  };

  injectAntiFlickerCSS();

  let isProcessing = false;
  let lastProcessedTime = 0;
  let observers = { drawer: null, rebuy: null };
  const productCache = new Map();
  const lastCartData = { page: null, drawer: null, rebuy: null };
  const rollupAlreadyDone = { page: false, drawer: false, rebuy: false };

  const fetchCartData = async () => {
    try {
      const response = await fetch('/cart.js');
      if (!response.ok) {
        throw new Error(`Cart fetch failed: ${response.status}`);
      }
      return await response.json();
    } catch (err) {
      return null;
    }
  };

  const fetchBundleProductData = async (bundleHandle, variantId) => {
    const cacheKey = `${bundleHandle}:${variantId}`;
    if (productCache.has(cacheKey)) {
      return productCache.get(cacheKey);
    }

    try {
      const response = await fetch(`/products/${bundleHandle}.js`);
      if (!response.ok) {
        throw new Error(`Product fetch failed: ${response.status}`);
      }

      const productData = await response.json();
      const result = {
        product: productData,
        variant: productData.variants.find(
          (v) => v.id.toString() === variantId.split('/').pop(),
        ),
      };
      productCache.set(cacheKey, result);
      return result;
    } catch (err) {
      return null;
    }
  };

  const groupBundleItems = (cartData) => {
    if (!cartData?.items) {
      return {};
    }
    return cartData.items.reduce((groups, item) => {
      const bundleId = item.properties?.['_bundleUid'];
      if (bundleId) {
        if (!groups[bundleId]) {
          groups[bundleId] = { items: [], properties: item.properties };
        }
        groups[bundleId].items.push(item);
      }
      return groups;
    }, {});
  };

  const getCartContext = () => {
    debug('getCartContext() called');
    const contexts = [];

    const rebuyCart = document.querySelector('#rebuy-cart, .rebuy-cart');
    if (
      rebuyCart &&
      (rebuyCart.classList.contains('is-visible') ||
        rebuyCart.getAttribute('aria-hidden') === 'false')
    ) {
      contexts.push({ type: 'rebuy', container: rebuyCart, theme: 'rebuy' });
      debug('Found Rebuy cart');
    }

    const drawerConfig = THEME.drawer;
    debug('Checking for drawer, drawerConfig:', drawerConfig);
    if (drawerConfig && !isRebuy(THEME.name)) {
      const drawer = document.querySelector(drawerConfig.selectors);
      debug('Drawer element:', drawer);
      debug(
        'Drawer visibility check:',
        drawer ? drawerConfig.visibilityCheck(drawer) : 'no drawer',
      );
      if (drawer && drawerConfig.visibilityCheck(drawer)) {
        contexts.push({ type: 'drawer', container: drawer, theme: THEME.name });
        debug(`Found ${THEME.name} drawer cart`);
      } else {
        const drawerCartItems = document.querySelector(
          drawerConfig.itemsComponent,
        );
        debug('Drawer cart items:', drawerCartItems);
        debug('Drawer cart items offsetParent:', drawerCartItems?.offsetParent);
        if (drawerCartItems?.offsetParent) {
          const closestDrawer = drawerCartItems.closest(
            drawerConfig.closestContainer,
          );
          contexts.push({
            type: 'drawer',
            container: closestDrawer || drawerCartItems,
            theme: THEME.name,
          });
          debug(`Found ${THEME.name} drawer cart (via items component)`);
        }
      }
    }

    debug('Checking for cart page, pathname:', window.location.pathname);
    const isCartPage =
      window.location.pathname.includes('/cart') ||
      document.querySelector(
        '.cart-page, [data-cart-page], main.cart, cart-items',
      );
    debug('isCartPage:', isCartPage);
    debug('THEME.name:', THEME.name);
    if (isCartPage && !isRebuy(THEME.name)) {
      contexts.push({ type: 'page', container: document, theme: THEME.name });
      debug('Found cart page');
    }

    debug('Final contexts:', contexts);
    return contexts.length > 0 ? contexts : null;
  };

  const findAndMatchCartItems = (cartData, tbody, selectors, themeName) => {
    const effectiveSelectors = selectors || THEME.selectors;
    const effectiveTheme = themeName || THEME.name;
    const matchedCartItemIndices = new Set();

    return Array.from(tbody.querySelectorAll(effectiveSelectors.cartItemRow))
      .map((row) => {
        let cartItem;
        let cartItemIndex = -1;

        if (row.dataset.key) {
          cartItemIndex = cartData.items.findIndex(
            (item) => item.key === row.dataset.key,
          );
          if (cartItemIndex !== -1) {
            cartItem = cartData.items[cartItemIndex];
          }
        } else if (isRebuy(effectiveTheme)) {
          const classList = Array.from(row.classList);
          const bundleUidClass = classList.find((c) =>
            c.startsWith('property-_bundleuid:'),
          );
          if (bundleUidClass) {
            const bundleUidFromClass = bundleUidClass.split(':')[1];
            cartItemIndex = cartData.items.findIndex(
              (item, idx) =>
                !matchedCartItemIndices.has(idx) &&
                item.properties?.['_bundleUid']?.replace(/-/g, '') ===
                  bundleUidFromClass,
            );
            if (cartItemIndex !== -1) {
              cartItem = cartData.items[cartItemIndex];
            }
          }
          if (!cartItem) {
            const productClass = classList.find(
              (c) => c.startsWith('product-') && !c.startsWith('product-id-'),
            );
            if (productClass) {
              const handle = productClass.replace('product-', '');
              cartItemIndex = cartData.items.findIndex(
                (item, idx) =>
                  !matchedCartItemIndices.has(idx) && item.handle === handle,
              );
              if (cartItemIndex !== -1) {
                cartItem = cartData.items[cartItemIndex];
              }
            }
          }
        } else if (effectiveTheme === 'Debut') {
          // Debut has no data-key; extract key from qty input id: "updates_VARIANTID:HASH"
          const qtyInput = row.querySelector('input.cart__qty-input');
          const inputId = qtyInput?.id;
          if (inputId?.startsWith('updates_')) {
            const key = inputId.replace('updates_', '');
            cartItemIndex = cartData.items.findIndex(
              (item, idx) =>
                !matchedCartItemIndices.has(idx) && item.key === key,
            );
            if (cartItemIndex !== -1) {
              cartItem = cartData.items[cartItemIndex];
            }
          }
        } else {
          // Dawn/Wonder: id="CartItem-N" or "CartDrawer-Item-N"
          const idMatch = row.id?.match(/Cart(?:Drawer-)?Item-(\d+)/);
          if (idMatch) {
            const index = parseInt(idMatch[1]) - 1;
            cartItem = cartData.items[index];
            cartItemIndex = index;
          }
        }

        if (cartItemIndex !== -1) {
          matchedCartItemIndices.add(cartItemIndex);
        }

        return cartItem ? { row, cartItem } : null;
      })
      .filter(Boolean);
  };

  const formatPrice = (cents) => {
    if (
      typeof window !== 'undefined' &&
      window.Shopify &&
      typeof window.Shopify.formatMoney === 'function'
    ) {
      try {
        return window.Shopify.formatMoney(cents);
      } catch (e) {
        // Fall back below
      }
    }
    return `$${(cents / 100).toFixed(2)}`;
  };

  const onDocReady = (fn) =>
    document.readyState === 'loading'
      ? document.addEventListener('DOMContentLoaded', fn)
      : fn();

  const updateElement = (element, props) =>
    element && Object.assign(element, props);
  const setStyles = (element, styles) =>
    element && Object.assign(element.style, styles);
  const queryInRow = (row, selector, selectors) => {
    const effectiveSelectors = selectors || THEME.selectors;
    return row.querySelector(effectiveSelectors[selector]);
  };

  const createBundleSubitem = (item) => {
    const subitem = document.createElement('div');
    subitem.className = 'bundle-subitem';
    subitem.style.cssText =
      'display: flex; align-items: flex-start; margin-bottom: 8px;';

    if (item.image) {
      const img = Object.assign(document.createElement('img'), {
        src: item.image,
        alt: item.product_title,
      });
      img.style.cssText =
        'width: 30px; height: 30px; margin-right: 8px; object-fit: cover; flex-shrink: 0;';
      subitem.appendChild(img);
    }

    const details = document.createElement('div');
    details.className = 'bundle-subitem-details';
    details.style.cssText = 'flex: 1; font-size: 0.875em; line-height: 1.4;';

    const titleDiv = document.createElement('div');
    titleDiv.style.cssText = 'font-weight: 500;';
    titleDiv.textContent = item.product_title;
    details.appendChild(titleDiv);

    if (item.variant_title && item.variant_title !== 'Default Title') {
      const variantDiv = document.createElement('div');
      variantDiv.style.cssText = 'color: #6b7280; font-size: 0.9em;';
      variantDiv.textContent = item.variant_title;
      details.appendChild(variantDiv);
    }

    const qtyDiv = document.createElement('div');
    qtyDiv.style.cssText = 'color: #6b7280; font-size: 0.9em; margin-top: 2px;';
    qtyDiv.textContent = `Qty: ${item.quantity}`;
    details.appendChild(qtyDiv);
    subitem.appendChild(details);
    return subitem;
  };

  const updateBundlePrices = (bundleRow, items, selectors) => {
    const effectiveSelectors = selectors || THEME.selectors;
    const totalPrice = items.reduce(
      (sum, item) => sum + item.final_line_price,
      0,
    );
    const totalOriginalPrice = items.reduce(
      (sum, item) => sum + item.original_line_price,
      0,
    );

    const unitPriceWrapper = queryInRow(
      bundleRow,
      'unitPriceWrapper',
      effectiveSelectors,
    );
    if (unitPriceWrapper) {
      updateElement(
        unitPriceWrapper.querySelector(
          'span:not(.visually-hidden):not(.compare-at-price)',
        ),
        { textContent: formatPrice(totalPrice) },
      );
      if (totalOriginalPrice > totalPrice) {
        updateElement(
          unitPriceWrapper.querySelector(effectiveSelectors.compareAtPrice),
          { textContent: formatPrice(totalOriginalPrice) },
        );
      }
    }
    updateElement(queryInRow(bundleRow, 'price', effectiveSelectors), {
      textContent: formatPrice(totalPrice),
    });
  };

  const disableBundleQuantityControls = (bundleRow, themeName, selectors) => {
    const effectiveTheme = themeName || THEME.name;
    const effectiveSelectors = selectors || THEME.selectors;
    const qtyElement = queryInRow(bundleRow, 'qtyInput', effectiveSelectors);
    if (isRebuy(effectiveTheme)) {
      if (qtyElement) {
        const textNodes = Array.from(qtyElement.childNodes).filter(
          (node) => node.nodeType === Node.TEXT_NODE,
        );
        if (textNodes.length > 0) {
          textNodes[0].textContent = ' 1 ';
        }
      }
    } else {
      updateElement(qtyElement, {
        value: '1',
        readOnly: true,
        disabled: true,
      });
    }
    bundleRow.querySelectorAll(effectiveSelectors.qtyButtons).forEach((btn) =>
      setStyles(btn, {
        visibility: 'hidden',
        opacity: '0',
        pointerEvents: 'none',
      }),
    );
  };

  const getWonderCartSections = (themeName) => {
    if (!isWonder(themeName)) {
      return [];
    }

    const cartItems = document.getElementById('main-cart-items');
    if (cartItems) {
      return [
        {
          id: 'main-cart-items',
          section: cartItems.dataset.id,
          selector: '.js-contents',
        },
        {
          id: 'cart-icon-bubble',
          section: 'cart-icon-bubble',
          selector: '.shopify-section',
        },
        {
          id: 'cart-live-region-text',
          section: 'cart-live-region-text',
          selector: '.shopify-section',
        },
        {
          id: 'main-cart-footer',
          section: document.getElementById('main-cart-footer')?.dataset.id,
          selector: '.js-contents',
        },
        {
          id: 'jp-main-cart-upsells',
          section: document.getElementById('jp-main-cart-upsells')?.dataset.id,
          selector: '.js-contents',
        },
      ].filter((section) => section.section);
    }

    return [
      {
        id: 'cart-drawer',
        section: 'cart-drawer',
        selector: '#CartDrawer',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
    ];
  };

  const renderWonderCartSections = (sections, sectionsToRender) => {
    if (!sections) {
      return;
    }

    sectionsToRender.forEach(({ id, section, selector }) => {
      const html = sections[section];
      if (!html) {
        return;
      }

      const parsed = new DOMParser().parseFromString(html, 'text/html');
      const currentSection = document.getElementById(
        `shopify-section-${section}`,
      );
      const incomingSection = parsed.getElementById(
        `shopify-section-${section}`,
      );

      if (
        (id === 'cart-icon-bubble' || id === 'cart-live-region-text') &&
        currentSection &&
        incomingSection
      ) {
        currentSection.innerHTML = incomingSection.innerHTML;
        return;
      }

      const currentRoot = document.getElementById(id);
      const currentTarget = currentRoot?.querySelector(selector) || currentRoot;
      const incoming = parsed.querySelector(selector);
      if (currentTarget && incoming) {
        currentTarget.innerHTML = incoming.innerHTML;
      }
    });
  };

  const setupRemoveButton = (bundleRow, bundleId, selectors, themeName) => {
    const effectiveSelectors = selectors || THEME.selectors;
    const effectiveTheme = themeName || THEME.name;

    // Capture ALL remove buttons before any DOM modifications
    const removeButtons = bundleRow.querySelectorAll(
      effectiveSelectors.removeButton,
    );
    if (removeButtons.length === 0) {
      return;
    }

    // Neutralize cart-remove-button custom elements: replace with plain <span>
    // so connectedCallback won't fire and register competing click handlers
    // when the bundle row is inserted into the DOM
    bundleRow.querySelectorAll('cart-remove-button').forEach((crb) => {
      const plain = document.createElement('span');
      plain.className = crb.className;
      if (crb.id) plain.id = crb.id;
      while (crb.firstChild) {
        plain.appendChild(crb.firstChild);
      }
      crb.parentNode.replaceChild(plain, crb);
    });

    const handleRemoveClick = async (e) => {
      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();
      setStyles(bundleRow, { opacity: '0.6', pointerEvents: 'none' });

      try {
        const wonderDrawer = isWonder(effectiveTheme)
          ? bundleRow.closest('cart-drawer')
          : null;
        const sectionsToRender = getWonderCartSections(effectiveTheme);
        const updates = {};
        (await (await fetch('/cart.js')).json()).items.forEach((item) => {
          if (item.properties?.['_bundleUid'] === bundleId) {
            updates[item.key] = 0;
          }
        });

        const response = await fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            updates,
            sections: sectionsToRender.map((section) => section.section),
            sections_url: window.location.pathname,
          }),
        });

        if (response.ok) {
          const updatedCartData = await response.json();
          bundleRow.remove();

          if (
            wonderDrawer &&
            typeof wonderDrawer.renderContents === 'function'
          ) {
            // Preserve Wonder's cart-drawer custom element and its open/focus
            // state while replacing the drawer body and cart badge together.
            wonderDrawer.renderContents(updatedCartData, false);
          } else {
            renderWonderCartSections(
              updatedCartData.sections,
              sectionsToRender,
            );
          }
          updateCartBubble(updatedCartData);

          if (
            typeof publish === 'function' &&
            typeof PUB_SUB_EVENTS !== 'undefined' &&
            PUB_SUB_EVENTS.cartUpdate
          ) {
            publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cart-items' });
          }

          Object.keys(lastCartData).forEach((contextType) => {
            lastCartData[contextType] = null;
            rollupAlreadyDone[contextType] = false;
          });
          lastProcessedTime = 0;
          await analyzeCart();
        } else {
          setStyles(bundleRow, { opacity: '', pointerEvents: '' });
        }
      } catch (error) {
        setStyles(bundleRow, { opacity: '', pointerEvents: '' });
      }
    };

    const bundleTitle =
      queryInRow(bundleRow, 'title', effectiveSelectors)?.textContent?.trim() ||
      'bundle';

    // The cloned cart-remove-button element is already neutralized above, so
    // bind directly to its link. Wonder absolutely positions this link; moving
    // it into an unpositioned wrapper creates a 0x0 touch target on Android.
    removeButtons.forEach((removeButton) => {
      removeButton.href = '#';
      removeButton.setAttribute('aria-label', `Remove ${bundleTitle}`);
      setStyles(removeButton, { cursor: 'pointer', pointerEvents: 'auto' });
      removeButton.addEventListener('click', handleRemoveClick);
    });
  };

  const updateBundleImage = (bundleRow, product, themeName, selectors) => {
    const effectiveTheme = themeName || THEME.name;
    const effectiveSelectors = selectors || THEME.selectors;
    const imageElement = queryInRow(bundleRow, 'image', effectiveSelectors);
    const mediaContainer = queryInRow(
      bundleRow,
      'imageContainer',
      effectiveSelectors,
    );

    if (product.featured_image) {
      updateElement(imageElement, {
        src: product.featured_image,
        srcset: product.featured_image,
        alt: product.title,
      });
      imageElement?.removeAttribute('data-srcset');
      imageElement?.removeAttribute('data-src');
      imageElement?.removeAttribute('data-widths');
      imageElement?.style.removeProperty('display');
      imageElement?.style.removeProperty('opacity');
      if (mediaContainer && effectiveTheme === 'Horizon') {
        setStyles(mediaContainer, {
          backgroundImage: `url(${product.featured_image})`,
          backgroundSize: 'contain',
          backgroundPosition: 'center',
          backgroundRepeat: 'no-repeat',
          backgroundColor: '',
        });
      }
    } else {
      setStyles(imageElement, { display: 'none' });
      setStyles(mediaContainer, {
        backgroundImage: 'none',
        backgroundColor: '#f3f4f6',
      });
    }
  };

  const addVariantAndSubscription = (
    variantsWrapper,
    variant,
    subscription,
  ) => {
    if (!variantsWrapper || !variant) {
      return;
    }

    const existingPropertyLists = Array.from(
      variantsWrapper.querySelectorAll('ul.list-unstyled'),
    );

    if (variant.title && variant.title !== 'Default Title') {
      const variantDiv = Object.assign(document.createElement('div'), {
        className: 'cart-items__variant',
        textContent: variant.title,
      });
      setStyles(variantDiv, { margin: '5px 0', display: 'block' });
      variantsWrapper.insertBefore(variantDiv, variantsWrapper.firstChild);
    }

    if (
      subscription?.selling_plan &&
      !existingPropertyLists.find((ul) =>
        ul.textContent.includes(subscription.selling_plan.name),
      )
    ) {
      const planList = Object.assign(document.createElement('ul'), {
        className: 'list-unstyled selling-plan',
      });
      const planItem = document.createElement('li');
      planItem.textContent = subscription.selling_plan.name;
      planList.appendChild(planItem);
      planList.setAttribute('role', 'list');
      (
        existingPropertyLists[existingPropertyLists.length - 1] ||
        variantsWrapper
      ).parentNode.insertBefore(
        planList,
        existingPropertyLists[existingPropertyLists.length - 1]?.nextSibling ||
          null,
      );
    }
  };

  const updateCartBubble = (cartData) => {
    const bundleGroups = groupBundleItems(cartData);
    const bundleItemKeys = new Set(
      Object.values(bundleGroups).flatMap((g) => g.items.map((i) => i.key)),
    );
    const bundleCount = Object.keys(bundleGroups).length;
    const standaloneCount = cartData.items
      .filter((i) => !bundleItemKeys.has(i.key))
      .reduce((sum, item) => sum + (item.quantity || 0), 0);
    const totalCount = bundleCount + standaloneCount;

    debug(
      `Updating cart bubble: ${totalCount} visible items (${bundleCount} bundles + ${standaloneCount} standalone)`,
    );

    const bubbleConfig = THEME.cartBubble;
    if (bubbleConfig) {
      const containers = document.querySelectorAll(bubbleConfig.container);

      document.querySelectorAll(bubbleConfig.count).forEach((el) => {
        el.textContent = totalCount;
      });

      containers.forEach((container) => {
        container
          .querySelectorAll(bubbleConfig.visuallyHidden)
          .forEach((el) => {
            el.textContent =
              THEME.name === 'Dawn'
                ? `${totalCount} items`
                : `Total items in cart: ${totalCount}`;
          });
      });

      containers.forEach((el) => {
        el.classList.add('awtomic-ready');
      });
    }
  };

  const createBundleRows = async (
    bundleGroups,
    matches,
    themeName,
    selectors,
  ) => {
    const effectiveTheme = themeName || THEME.name;
    const effectiveSelectors = selectors || THEME.selectors;

    for (const [bundleId, group] of Object.entries(bundleGroups)) {
      const containerSelector = isRebuy(effectiveTheme)
        ? 'ul[data-smartcart-items]'
        : effectiveTheme === 'Supply'
          ? '.cart__items'
          : isWonder(effectiveTheme)
            ? 'ul.wt-cart__list'
            : 'tbody';
      const itemSelector = isRebuy(effectiveTheme)
        ? `li[data-bundle-id="${bundleId}"]`
        : effectiveTheme === 'Supply'
          ? `.cart__item[data-bundle-id="${bundleId}"]`
          : `[data-bundle-id="${bundleId}"]`;

      if (
        matches[0]?.row.closest(containerSelector)?.querySelector(itemSelector)
      ) {
        continue;
      }

      const bundleProductData =
        group.properties._bundleHandle && group.properties._variantId
          ? await fetchBundleProductData(
              group.properties._bundleHandle,
              group.properties._variantId,
            )
          : null;

      const firstMatch = matches.find(
        (m) => m.cartItem.key === group.items[0].key,
      );
      if (!firstMatch) {
        continue;
      }

      const bundleRow = firstMatch.row.cloneNode(true);
      Object.assign(bundleRow.dataset, {
        bundleId,
        bundleHandle: group.properties._bundleHandle,
        awtomicBundle: 'true',
        key: `bundle-${bundleId}`,
      });

      // Always clear old variant/property content (e.g. _bundleUid, _bundleHandle)
      const oldVariants = bundleRow.querySelector(effectiveSelectors.variants);
      if (oldVariants) {
        oldVariants.remove();
      }

      if (bundleProductData?.product) {
        const { product, variant } = bundleProductData;
        const productUrl = `/products/${product.handle}${variant ? `?variant=${variant.id}` : ''}`;

        updateElement(queryInRow(bundleRow, 'title', effectiveSelectors), {
          textContent: product.title,
          href: productUrl,
        });
        const imageLink = queryInRow(
          bundleRow,
          'imageLink',
          effectiveSelectors,
        );
        if (imageLink) {
          imageLink.href = productUrl;
          imageLink.setAttribute('aria-label', product.title);
        }

        updateBundleImage(
          bundleRow,
          product,
          effectiveTheme,
          effectiveSelectors,
        );

        const variantsWrapper = bundleRow.querySelector(
          effectiveSelectors.variantsWrapper,
        );
        if (variantsWrapper && variant) {
          addVariantAndSubscription(
            variantsWrapper,
            variant,
            group.items[0].selling_plan_allocation,
          );

          const subitemsContainer = Object.assign(
            document.createElement('div'),
            { className: 'bundle-subitems' },
          );
          setStyles(subitemsContainer, { marginTop: '15px' });
          group.items.forEach((item) =>
            subitemsContainer.appendChild(createBundleSubitem(item)),
          );
          variantsWrapper.appendChild(subitemsContainer);
        }
      }

      updateBundlePrices(bundleRow, group.items, effectiveSelectors);
      disableBundleQuantityControls(
        bundleRow,
        effectiveTheme,
        effectiveSelectors,
      );
      setupRemoveButton(
        bundleRow,
        bundleId,
        effectiveSelectors,
        effectiveTheme,
      );

      firstMatch.row.parentNode.insertBefore(bundleRow, firstMatch.row);
      debug(
        `Hiding ${group.items.length} items for bundle ${bundleId}:`,
        group.items.map((i) => i.key),
      );
      group.items.forEach((item) => {
        const match = matches.find((m) => m.cartItem.key === item.key);
        if (match) {
          debug(`  ✓ Hiding item ${item.key}`);
          match.row.style.display = 'none';
          match.row.dataset.awtomicHidden = 'true';
        } else {
          debug(`  ✗ Could not find match for item ${item.key}`);
        }
      });
    }
  };

  const analyzeCart = async () => {
    debug('analyzeCart() called');

    if (isProcessing || Date.now() - lastProcessedTime < 2000) {
      debug('Skipping: already processing or too soon');
      return;
    }

    try {
      const newTheme = detectTheme();
      if (newTheme.name !== THEME.name) {
        debug(`Theme changed from ${THEME.name} to ${newTheme.name}`);
        THEME = newTheme;
      }

      debug('Getting cart context...');
      const contexts = getCartContext();
      debug('Cart contexts:', contexts);

      if (!contexts) {
        debug('No cart contexts found');
        removeAntiFlickerCSS();
        return;
      }

      debug('Fetching cart data...');
      const cartData = await fetchCartData();
      debug(
        'Cart data fetched:',
        cartData ? `${cartData.items.length} items` : 'null',
      );

      if (!cartData) {
        debug('No cart data returned');
        removeAntiFlickerCSS();
        return;
      }

      debug(`Found ${contexts.length} cart context(s) to process`);

      for (const context of contexts) {
        debug(
          `Analyzing ${context.type} cart (${context.theme}) with ${cartData.items.length} items`,
        );

        await processCartContext(context, cartData);
      }

      updateCartBubble(cartData);
      removeAntiFlickerCSS();
    } catch (error) {
      console.error('[Awtomic Cart Rollup] Error in analyzeCart:', error);
      removeAntiFlickerCSS();
    }
  };

  const processCartContext = async (context, cartData) => {
    const contextType = context.type;
    if (
      lastCartData[contextType]?.items.length === cartData.items.length &&
      lastCartData[contextType].items.every((item, i) => {
        const newItem = cartData.items[i];
        return (
          newItem &&
          item.key === newItem.key &&
          item.quantity === newItem.quantity
        );
      })
    ) {
      debug(`Cart data unchanged for ${contextType}, skipping`);
      return;
    }

    lastCartData[contextType] = cartData;
    isProcessing = true;
    lastProcessedTime = Date.now();

    let itemsContainer, originalContainer;

    try {
      const contextTheme = context.theme;
      const themeSelectors = isRebuy(contextTheme)
        ? themeDefinitions.themes.rebuy.selectors
        : THEME.selectors;

      if (isRebuy(contextTheme)) {
        itemsContainer = context.container.querySelector(
          'ul[data-smartcart-items], .rebuy-cart__flyout-items',
        );
        originalContainer = itemsContainer;
        debug(`Rebuy container found: ${!!originalContainer}`);
      } else if (contextTheme === 'Supply') {
        if (context.type === 'drawer') {
          itemsContainer = context.container.querySelector('.cart__items');
        } else {
          const dataProductsContainers =
            document.querySelectorAll('[data-products]');
          for (const container of dataProductsContainers) {
            if (container.querySelector('.cart__item')) {
              itemsContainer = container;
              break;
            }
          }
          if (!itemsContainer) {
            itemsContainer = document.querySelector(
              '[data-products], .cart__items',
            );
          }
        }
        originalContainer = itemsContainer;
        debug(
          `Supply container found: ${!!originalContainer}`,
          originalContainer,
        );
      } else if (isWonder(contextTheme)) {
        // Wonder uses ul.wt-cart__list for both drawer and page
        itemsContainer = (
          context.type === 'drawer' ? context.container : document
        ).querySelector('ul.wt-cart__list');
        originalContainer = itemsContainer;
        debug(
          `Wonder container found: ${!!originalContainer}`,
          originalContainer,
        );
      } else {
        const cartTable = (
          context.type === 'drawer' ? context.container : document
        ).querySelector(
          '.cart-items__table, table.cart-items, form.cart > table',
        );
        originalContainer = cartTable?.querySelector('tbody');
        itemsContainer = cartTable;
      }

      if (!originalContainer) {
        debug(`No original container found for ${contextTheme} cart`);
        return;
      }

      if (!isDirectTheme(contextTheme)) {
        if (itemsContainer) {
          itemsContainer.classList.add('awtomic-ready');
        }
        if (originalContainer && originalContainer !== itemsContainer) {
          originalContainer.classList.add('awtomic-ready');
        }
      }

      const bundleGroups = groupBundleItems(cartData);
      const bundleGroupCount = Object.keys(bundleGroups).length;

      if (bundleGroupCount > 0) {
        debug(
          `Found ${bundleGroupCount} bundle group(s):`,
          Object.keys(bundleGroups),
        );

        const bundleItemKeys = new Set(
          Object.values(bundleGroups).flatMap((g) => g.items.map((i) => i.key)),
        );
        const bundleUids = Object.keys(bundleGroups);

        debug(
          `Bundle item keys from cart API (${bundleItemKeys.size}):`,
          Array.from(bundleItemKeys).slice(0, 5),
        );

        const allRows = Array.from(
          originalContainer.querySelectorAll(themeSelectors.cartItemRow),
        );
        debug(
          `Found ${allRows.length} total rows in DOM with selector "${themeSelectors.cartItemRow}"`,
        );
        debug(
          'First 5 DOM row keys:',
          allRows.slice(0, 5).map((r) => r.dataset.key || r.id),
        );

        const visibleBundleItems = allRows.filter((row) => {
          if (isRebuy(contextTheme)) {
            const classList = Array.from(row.classList);
            const bundleUidClass = classList.find((c) =>
              c.startsWith('property-_bundleuid:'),
            );
            if (bundleUidClass) {
              const bundleUidFromClass = bundleUidClass.split(':')[1];
              const normalizedClassUid = bundleUidFromClass.replace(/-/g, '');
              return bundleUids.some(
                (uid) => uid.replace(/-/g, '') === normalizedClassUid,
              );
            }
            return false;
          } else {
            let rowKey = row.dataset.key || row.id;
            // Debut: extract key from qty input id (updates_VARIANTID:HASH)
            if (!rowKey) {
              const qtyInput = row.querySelector('input.cart__qty-input');
              const inputId = qtyInput?.id;
              if (inputId?.startsWith('updates_')) {
                rowKey = inputId.replace('updates_', '');
              }
            }
            // Dawn/Wonder: resolve index-based id to actual cart item key
            const indexIdMatch = rowKey?.match(/^Cart(?:Drawer-)?Item-(\d+)$/);
            if (indexIdMatch) {
              const idx = parseInt(indexIdMatch[1]) - 1;
              if (cartData.items[idx]) {
                rowKey = cartData.items[idx].key;
              }
            }
            const hasKey = bundleItemKeys.has(rowKey);
            const isVisible = row.offsetParent !== null;
            if (!hasKey && rowKey) {
              debug(
                `Row key "${rowKey}" not found in bundleItemKeys (first check)`,
              );
            }
            return hasKey && isVisible;
          }
        });

        debug(`Found ${visibleBundleItems.length} visible bundle items in DOM`);

        if (bundleItemKeys.size > 0 && visibleBundleItems.length === 0) {
          debug(
            `Detected server-side rollup for ${context.type} cart (${bundleItemKeys.size} bundle items hidden in DOM)`,
          );
          rollupAlreadyDone[context.type] = true;
          return;
        }
      } else {
        debug('No bundle groups found in cart');
        return;
      }

      if (isRebuy(contextTheme)) {
        originalContainer
          .querySelectorAll('li.awtomic-processed, li[data-awtomic-hidden]')
          .forEach((item) => item.remove());
      } else if (contextTheme === 'Supply') {
        originalContainer
          .querySelectorAll(
            '.cart__item.awtomic-processed, .cart__item[data-awtomic-hidden]',
          )
          .forEach((item) => item.remove());
      } else if (isWonder(contextTheme)) {
        originalContainer
          .querySelectorAll('li[data-awtomic-bundle], li[data-awtomic-hidden]')
          .forEach((item) => item.remove());
      } else {
        itemsContainer
          .querySelectorAll('tbody.awtomic-processed')
          .forEach((clone) => clone.remove());
      }

      let containerToProcess;
      if (isDirectTheme(contextTheme)) {
        containerToProcess = originalContainer;
      } else {
        containerToProcess = originalContainer.cloneNode(true);
        containerToProcess.classList.add('awtomic-processed');
        containerToProcess.classList.remove('awtomic-original');
      }

      if (bundleGroupCount > 0) {
        const matches = findAndMatchCartItems(
          cartData,
          containerToProcess,
          themeSelectors,
          contextTheme,
        );
        debug(
          `Matched ${matches.length} items out of ${cartData.items.length} cart items`,
        );
        debug(
          'Matched cart item keys:',
          matches.map((m) => m.cartItem.key),
        );
        await createBundleRows(
          bundleGroups,
          matches,
          contextTheme,
          themeSelectors,
        );
      }

      if (isDirectTheme(contextTheme)) {
        if (itemsContainer) {
          itemsContainer.classList.add('awtomic-ready');
        }
        if (originalContainer && originalContainer !== itemsContainer) {
          originalContainer.classList.add('awtomic-ready');
        }
      } else {
        originalContainer.classList.add('awtomic-original');
        itemsContainer.appendChild(containerToProcess);
      }

      rollupAlreadyDone[contextType] = true;

      debug(`Cart rollup completed for ${context.type} cart (${contextTheme})`);
    } catch (error) {
      console.error(
        `[Awtomic Cart Rollup] Error processing ${context.type} cart:`,
        error,
      );
    } finally {
      isProcessing = false;
    }
  };

  const setupEventListeners = () => {
    const createObserver = (callback, options = {}) => {
      const safeCallback = (...args) => {
        try {
          callback(...args);
        } catch (error) {
          console.error(
            '[Awtomic Cart Rollup] Observer callback error:',
            error,
          );
        }
      };
      const observer = new MutationObserver(safeCallback);
      return {
        observe: (el) => observer.observe(el, options),
        disconnect: () => observer.disconnect(),
      };
    };

    [
      'cart:update',
      'cart:updated',
      'cart:refresh',
      'cart:refreshed',
      'cart-drawer:open',
      'cart-drawer:updated',
      'cart-drawer:refresh',
      'drawer:open',
      'cart:open',
      'theme:cart:open',
      'ajaxCart.afterCartLoad',
      'drawer.didOpen',
    ].forEach((e) =>
      document.addEventListener(e, () => {
        try {
          analyzeCart();
        } catch (error) {
          console.error('[Awtomic Cart Rollup] Event listener error:', error);
        }
      }),
    );

    document.addEventListener('click', (e) => {
      try {
        if (
          e.target.closest(
            '[data-open-drawer], [data-cart-drawer], .cart-icon, [href="#cart-drawer"], .js-drawer-open-right, [data-ajax-cart-toggle-class-button]',
          )
        ) {
          analyzeCart();
        }
      } catch (error) {
        console.error('[Awtomic Cart Rollup] Click handler error:', error);
      }
    });

    const observeDrawer = () => {
      if (!THEME.drawer) {
        return;
      }
      if (observers.drawer) {
        observers.drawer.disconnect();
      }

      observers.drawer = createObserver(
        (mutations) => {
          for (const m of mutations) {
            if (
              m.type === 'attributes' &&
              (m.attributeName === 'open' ||
                m.attributeName === 'class' ||
                m.attributeName === 'aria-hidden')
            ) {
              if (
                m.target.hasAttribute('open') ||
                m.target.classList.contains('active') ||
                m.target.classList.contains('is-open') ||
                m.target.classList.contains('drawer--is-open') ||
                m.target.classList.contains('is-visible')
              ) {
                analyzeCart();
                break;
              }
            }
          }
        },
        {
          attributes: true,
          attributeFilter: ['open', 'class', 'aria-hidden'],
        },
      );

      document
        .querySelectorAll(
          'cart-drawer, [id*="cart-drawer"], [class*="cart-drawer"], #CartDrawer',
        )
        .forEach((drawer) => observers.drawer.observe(drawer));
    };

    const observeRebuyCart = () => {
      if (observers.rebuy) {
        observers.rebuy.disconnect();
      }

      const rebuyCart = document.querySelector('#rebuy-cart, .rebuy-cart');
      if (rebuyCart) {
        debug('Setting up Rebuy cart observer');
        observers.rebuy = createObserver(
          (mutations) => {
            for (const m of mutations) {
              if (
                m.type === 'attributes' &&
                (m.attributeName === 'class' ||
                  m.attributeName === 'aria-hidden')
              ) {
                if (
                  m.target.classList.contains('is-visible') ||
                  m.target.getAttribute('aria-hidden') === 'false'
                ) {
                  debug('Rebuy cart opened, analyzing...');
                  analyzeCart();
                  break;
                }
              }
            }
          },
          {
            attributes: true,
            attributeFilter: ['class', 'aria-hidden'],
          },
        );
        observers.rebuy.observe(rebuyCart);
      }
    };

    const observeCartPage = () => {
      if (window.location.pathname.includes('/cart')) {
        const cartTable = document.querySelector(
          'table.cart-items, .cart-items__table, form.cart > table',
        );
        if (cartTable) {
          createObserver(() => setTimeout(analyzeCart, 100), {
            childList: true,
            subtree: true,
            attributes: true,
            attributeFilter: ['class'],
          }).observe(cartTable);
        }

        if (THEME.name === 'Supply') {
          const cartPageContainer = document.querySelector('[data-products]');
          if (cartPageContainer) {
            createObserver(() => setTimeout(analyzeCart, 150), {
              childList: true,
              subtree: true,
              attributes: true,
              attributeFilter: ['class'],
            }).observe(cartPageContainer);
          }
        }
      }

      if (THEME.name === 'Supply') {
        const cartItems = document.querySelector('.cart__items');
        if (cartItems) {
          createObserver(() => setTimeout(analyzeCart, 150), {
            childList: true,
            subtree: true,
            attributes: true,
            attributeFilter: ['class', 'data-count'],
          }).observe(cartItems);
        }
      }

      // Observe Wonder theme's cart list
      if (THEME.name === 'Wonder') {
        document.querySelectorAll('ul.wt-cart__list').forEach((list) => {
          createObserver(() => setTimeout(analyzeCart, 150), {
            childList: true,
            subtree: true,
          }).observe(list);
        });
      }
    };

    const onReady = () => {
      observeDrawer();
      observeRebuyCart();
      observeCartPage();

      // Wonder publishes this after its cart sections have been replaced.
      // Re-run the rollup against the new DOM instead of relying on observers
      // attached to the cart list that Wonder just removed.
      if (
        isWonder(THEME.name) &&
        typeof subscribe === 'function' &&
        typeof PUB_SUB_EVENTS !== 'undefined' &&
        PUB_SUB_EVENTS.cartUpdate
      ) {
        subscribe(PUB_SUB_EVENTS.cartUpdate, () => {
          Object.keys(lastCartData).forEach((contextType) => {
            lastCartData[contextType] = null;
            rollupAlreadyDone[contextType] = false;
          });
          lastProcessedTime = 0;
          setTimeout(() => analyzeCart(), 0);
        });
      }
    };

    onDocReady(onReady);
  };

  const init = async () => {
    try {
      const cartData = await fetchCartData();
      if (cartData) {
        await Promise.all(
          Object.values(groupBundleItems(cartData))
            .filter(
              (g) => g.properties._bundleHandle && g.properties._variantId,
            )
            .map((g) =>
              fetchBundleProductData(
                g.properties._bundleHandle,
                g.properties._variantId,
              ),
            ),
        );
      }

      setupEventListeners();

      const run = () => {
        analyzeCart();
        fetchCartData().then((data) => data && updateCartBubble(data));
      };

      onDocReady(run);

      const pollMs = 25;
      pollInterval = setInterval(() => {
        const rebuyVisible = !!document.querySelector(
          '#rebuy-cart.is-visible, .rebuy-cart.is-visible, #rebuy-cart[aria-hidden="false"]',
        );
        const wonderDrawerEl = document.querySelector('.wt-cart__drawer__body');
        const supplyDrawerVisible =
          !!document.querySelector('.drawer--is-open') ||
          (wonderDrawerEl && wonderDrawerEl.offsetParent !== null);

        if (rebuyVisible && !lastVisibleCarts.rebuy) {
          debug('🔔 Rebuy cart opened - triggering rollup analysis');
          lastVisibleCarts.rebuy = true;
          rollupAlreadyDone.rebuy = false;
          setTimeout(() => analyzeCart(), 10);
        } else if (!rebuyVisible && lastVisibleCarts.rebuy) {
          debug('🔔 Rebuy cart closed');
          lastVisibleCarts.rebuy = false;
        }

        if (supplyDrawerVisible && !lastVisibleCarts.drawer) {
          debug('🔔 Supply drawer opened - triggering rollup analysis');
          lastVisibleCarts.drawer = true;
          rollupAlreadyDone.drawer = false;
          setTimeout(() => analyzeCart(), 10);
        } else if (!supplyDrawerVisible && lastVisibleCarts.drawer) {
          debug('🔔 Supply drawer closed');
          lastVisibleCarts.drawer = false;
        }
      }, pollMs);

      debug(`✓ Auto-detection enabled (checks every ${pollMs}ms)`);
      debug(`Total detection latency: ~${pollMs + 10}ms worst case`);

      window.awtomicCartRollup = {
        analyze: analyzeCart,
        version: '1.0.0',
        get theme() {
          return THEME;
        },
        stopPolling: () => {
          if (pollInterval) {
            clearInterval(pollInterval);
            pollInterval = null;
            debug('✓ Auto-detection stopped');
          }
        },
      };
    } catch (error) {
      console.error(
        '[Awtomic Cart Rollup] Error during initialization:',
        error,
      );
      removeAntiFlickerCSS();
    }
  };

  try {
    init();
  } catch (error) {
    console.error('[Awtomic Cart Rollup] Fatal error:', error);
    removeAntiFlickerCSS();
  }
})();
